import React from 'react';
import { MainAdminPage } from '../../pages/main-admin-page/ui/main-admin-page';
import { CatalogPage } from '../../pages/catalog-page/ui/catalog-page';
import { EmployeesPage } from '../../pages/emplaoyees-page/ui/employees-page';
import { useCurrentUserSelector } from '../../entities/current-user/model/selectors';
import {
    ROUTE_ADMIN_APPROVE,
    ROUTE_ADMIN_CATALOG,
    ROUTE_ADMIN_CATALOGS,
    ROUTE_ADMIN_EMPLOYEES,
    ROUTE_ADMIN_MAIN,
    ROUTE_ADMIN_ORDERS,
    ROUTE_ADMIN_ORGANIZATIONS,
    ROUTE_ADMIN_PRODUCT_BASE,
    ROUTE_ADMIN_PRODUCT_BUY_ORDER_BASE,
    ROUTE_ADMIN_PRODUCT_CREATE_ORDER_BASE,
    ROUTE_ADMIN_USERS,
    ROUTE_LOGIN,
    ROUTE_ADMIN_PROFILE,
    ROUTE_ADMIN_FILES,
    ROUTE_ADMIN_APPEALS,
} from '../../shared/config/routes/routes';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ProductPage } from '../../pages/product-page/ui/product-page';
import { ProductPurchasePage } from '../../pages/product-purchase-page/ui/product-purchase-page';
import { ApprovalManagerPage } from '../../pages/approval-manager-page/ui/approval-manager-page';
import { ApprovalEmployeePage } from '../../pages/approval-employee-page/ui/approval-employee-page';
import { UsersManagementPage } from '../../pages/users-management-page/ui/users-management-page';
import { OrganizationsManagementPage } from '../../pages/organizations-management-page/ui/organizations-management-page';
import { OrdersAdminPage } from '../../pages/orders-admin-page/ui/orders-admin-page';
import { UserRoles } from '@shared/model/user';
import { getCurrentUserRole } from '@shared/lib/utils/get-current-user-role/get-current-user-role';
import { getCredentials } from '@shared/lib/utils/credentials/credentials';
import { useCurrentUser } from '@app/lib/hooks/use-current-user/use-current-user';
import { useCurrentOrganizationPreview } from '@app/lib/hooks/use-current-organization-preview/use-current-organization-preview';
import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';
import { ProfilePage } from '@pages/profile/ui/profile';
import { FilesManagementPage } from '@pages/files-management-page/ui/files-management-page';
import { AdminCatalogPage } from '@pages/admin-catalog-page/ui/admin-catalog-page';
import { AdminCatalogProductsPage } from '@pages/admin-catalog-products-page/ui/admin-catalog-products-page';
import { AdminAppealsPage } from '@pages/admin-appeals-page/ui/admin-appeals-page';

export const AdminRouter: React.FC = () => {
    const user = useCurrentUserSelector();
    const role = getCurrentUserRole(user);
    const credentials = getCredentials();

    const hasCredentials = credentials.accessToken || credentials.refreshToken;

    const { isLoadingUser, userError, isInitialized } = useCurrentUser();
    useCurrentOrganizationPreview();

    if (hasCredentials && !user && (isLoadingUser || userError)) {
        return (
            <NetworkStateNew
                isInitialized={isInitialized}
                isLoading={isLoadingUser}
                isError={Boolean(userError)}
                hasData={Boolean(user)}
                isFiltered={false}
                errorProps={{ title: 'Ошибка загрузки учетной записи', description: userError?.message }}
                emptyProps={{ title: 'Отсутствуют данные учетной записи', description: 'Попробуйте обновить страницу' }}
            />
        );
    }

    if (role === UserRoles.Admin) {
        return (
            <Switch>
                <Route path={ROUTE_ADMIN_MAIN} component={MainAdminPage} />
                <Route path={ROUTE_ADMIN_CATALOGS} component={AdminCatalogPage} exact />
                <Route path={`${ROUTE_ADMIN_CATALOGS}/:id`} component={AdminCatalogProductsPage} />
                <Route path={ROUTE_ADMIN_APPEALS} component={AdminAppealsPage} />
                <Route path={ROUTE_ADMIN_ORGANIZATIONS} component={OrganizationsManagementPage} />
                <Route path={ROUTE_ADMIN_USERS} component={UsersManagementPage} />
                <Route path={ROUTE_ADMIN_ORDERS} component={OrdersAdminPage} />
                <Route path={`${ROUTE_ADMIN_PRODUCT_BASE}/:id`} component={ProductPage} />
                <Route path={ROUTE_ADMIN_PROFILE} component={ProfilePage} />
                <Route path={ROUTE_ADMIN_FILES} component={FilesManagementPage} />
                <Redirect to={ROUTE_ADMIN_MAIN} />
            </Switch>
        );
    }

    if (role === UserRoles.Employee) {
        return (
            <Switch>
                <Route path={ROUTE_ADMIN_MAIN} component={MainAdminPage} />
                <Route path={ROUTE_ADMIN_CATALOG} component={CatalogPage} />
                <Route path={`${ROUTE_ADMIN_PRODUCT_BASE}/:id`} component={ProductPage} />
                <Route path={`${ROUTE_ADMIN_PRODUCT_CREATE_ORDER_BASE}/:id`} component={ProductPurchasePage} />
                <Route path={ROUTE_ADMIN_APPROVE} component={ApprovalEmployeePage} />
                <Route path={ROUTE_ADMIN_PROFILE} component={ProfilePage} />
                <Redirect to={ROUTE_ADMIN_MAIN} />
            </Switch>
        );
    }

    if (role === UserRoles.Manager) {
        return (
            <Switch>
                <Route path={ROUTE_ADMIN_MAIN} component={MainAdminPage} />
                <Route path={ROUTE_ADMIN_CATALOG} component={CatalogPage} />
                <Route path={`${ROUTE_ADMIN_PRODUCT_BASE}/:id`} component={ProductPage} />
                <Route path={`${ROUTE_ADMIN_PRODUCT_BUY_ORDER_BASE}/:id`} component={ProductPurchasePage} />
                <Route path={ROUTE_ADMIN_EMPLOYEES} component={EmployeesPage} />
                <Route path={ROUTE_ADMIN_APPROVE} component={ApprovalManagerPage} />
                <Route path={ROUTE_ADMIN_PROFILE} component={ProfilePage} />
                <Redirect to={ROUTE_ADMIN_MAIN} />
            </Switch>
        );
    }

    return (
        <Switch>
            <Redirect to={ROUTE_LOGIN} />
        </Switch>
    );
};
